{"pleaseChooseYour":"VUI LÒNG CHỌN","deliveryLocation":"ĐỊA ĐIỂM GIAO HÀNG","viewAllAvailableLocations":"XEM TẤT CẢ ĐỊA ĐIỂM CÓ SẴN","go":"CHỌN"}